// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles_breadcrumbs__Bd8Q+","link":"styles_link__eMgmX"};